import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "legal-client",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                formOfUsage: "",
                legalName: "",
                ipn: "",
                fullName: "",
                phone: "",
            },
            validationErrors: {},
        };
    },
    validations() {
        return {
            payload: {
                formOfUsage: {
                    required,
                },
                legalName: {
                    required,
                },
                ipn: {
                    required,
                },
                fullName: {
                    required,
                },
                phone: {
                    required,
                },
            },
        };
    },
    computed: {
        formOfUsageErrors() {
            let error = [];
            if (!this.$v.payload.formOfUsage.$dirty) {
                return error;
            }
            if (!this.$v.payload.formOfUsage.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.formOfUsage) {
                this.validationErrors.formOfUsage.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        legalNameErrors() {
            let error = [];
            if (!this.$v.payload.legalName.$dirty) {
                return error;
            }
            if (!this.$v.payload.legalName.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.legalName) {
                this.validationErrors.legalName.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        ipnErrors() {
            let error = [];
            if (!this.$v.payload.ipn.$dirty) {
                return error;
            }
            if (!this.$v.payload.ipn.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.ipn) {
                this.validationErrors.ipn.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        fullNameErrors() {
            let error = [];
            if (!this.$v.payload.fullName.$dirty) {
                return error;
            }
            if (!this.$v.payload.fullName.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.fullName) {
                this.validationErrors.fullName.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            addAgentClient: `profile/ADD_NEW_AGENT_CLIENT`,
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
        }),
        cancel() {
            this.payload.fullName = "";
            this.payload.formOfUsage = "";
            this.payload.legalName = "";
            this.payload.ipn = "";
            this.payload.phone = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {};
                obj.type = 2;
                obj.form_of_management = this.payload.formOfUsage;
                obj.full_legal_name = this.payload.legalName;
                obj.contact_person_name = this.payload.fullName;
                obj.ipn = this.payload.ipn;
                obj.contact_person_phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                this.addAgentClient(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("newAgentClientAdded"));
                        this.fetchAgentClients();
                        this.cancel();
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log(error.response.status);
                        }
                    });
            }
        },
    },
};
